import { z } from 'zod'

import { nanoidSchema } from '@/utility'

export const headingRecordSchema = z
  .object({
    slug: z.string(),
    name: z.string(),
    level: z.coerce.number().int(),
    uid: nanoidSchema,
    parent: z.string().optional(),
  })
  .meta({ id: 'heading-record' })

/** Representation of an asset to publish */
export const publishAssetSchema = z
  .object({
    path: z.string(),
    data: z.string(),
  })
  .meta({ id: 'publish-asset' })

export type PublishAsset = z.infer<typeof publishAssetSchema>

/**
 * Heading record for page headings in rendered docs
 * Extracted during YJS rendering of the page
 */
export type HeadingRecord = z.infer<typeof headingRecordSchema>

/**
 * Path resolver functions are executed in the guide-render pipeline.
 */
export type PathResolverFunction = (
  path: string,
  localFilepath: string,
) => string | undefined

// ---------------------------------------------------------------------------

export const typesenseConfigSchema = z
  .object({
    keyId: z.number(),
    keyValue: z.string(),
    collectionName: z.string(),
  })
  .meta({ id: 'typesense-config' })

export type TypesenseConfig = z.infer<typeof typesenseConfigSchema>

// ---------------------------------------------------------------------------

export type StaticDoc = {
  error: false
  html: string
  markdown: string
  headings: Record<string, HeadingRecord>
}

export type StaticDocError = {
  error: true
  message: string
}

/**
 * This matches the timeout for the publish-deploy Cloud Run service.
 *
 * This ensures that we expect a max timeout at the same time as a service timeout.
 *
 * Will be deprecated once publishing moves to PubSub
 */
export const PUBLISH_REQUEST_TIMEOUT_SECONDS = 1200
